import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from "./screens/home/home";
import NotFound from "./screens/not_found/not_found";
import Calibration from "./screens/calibration/calibration";
import Tag from "./components/Tag/Tag";

export default function RouteContainer() {
    return (
        <Routes>
            <Route path='/' element={<Home/>}/>
            <Route path='/calibration' element={<Calibration/>}/>
            <Route path="/tag" element={<Tag />} />
            <Route path="*" element={<NotFound/>}/>
        </Routes>
    );
}